import {
  sendGoogleEvent,
  sendRequest,
  byWindowAction,
  isElementOnScreen,
} from '@html/_common/utils';

export default function AOSustainabiltyPopup(common) {
  let layout = null;
  const READ_MORE_SELECTOR = '.js-ao-sustainability-initiatives-read-more';
  const EVENT_CATEGORY = 'Tour Detail';
  const SCROLL_ACTION = 'Scroll';
  const $card = $('.js-ao-sustainability-initiatives__item');
  const $operatorDescription = $('.js-ao-sustainability-operator-description');
  const modalCloseBtn = '.js-ao-sustainability-initiatives-popup__close';
  const $initiativesBlock = $('.ao-sustainability-initiatives');
  const scrollElementList = [];
  const timerStart = Date.now();
  const endSustainabilityLabel = 'End of Sustainability';

  this.common = typeof sendGoogleEvent !== 'undefined' ? {
    sendGoogleEvent,
    sendRequest,
    byWindowAction,
    func: { isElementOnScreen },
  } : common;

  this.CheckIfElementExist = () => {
    if (!$initiativesBlock && !$initiativesBlock.height()) {
      this.common.sendGoogleEvent(
        EVENT_CATEGORY,
        'Section Not Loaded',
        'Sustainability',
        {
          nonInteraction: true,
        },
      );
      return;
    }

    const initiativesNames = $card.map((index, el) => el.getAttribute('data-initiative-name'));

    this.common.sendGoogleEvent(
      EVENT_CATEGORY,
      `Section Loaded - [${initiativesNames.selector}]`,
      'Sustainability',
      {
        nonInteraction: true,
      },
    );
  };

  this.initiate = () => {
    this.CheckIfElementExist();
    this.processScroll();

    if ($card.length) {
      $card.on('click', (event) => {
        const $currentTarget = $(event.currentTarget);
        const operatorId = $card.data('operator-id');
        const initiativeName = $currentTarget.data('initiative-name');

        if (!layout) {
          this.common.sendRequest('/api/popup/load-sustainability', { operatorId }, (data) => {
            if (data.status === 'OK') {
              layout = data.html;
              this.showPopup();
            }
          });
        } else {
          this.showPopup();
        }

        this.common.sendGoogleEvent(
          EVENT_CATEGORY,
          `Modal Open - ${initiativeName}`,
          'Sustainability',
          {
            ampEventName: 'tdp_sustainability_card_clicked',
            tdp_sustainability_card_clicked_element: `${initiativeName}`,
          },
        );
      });
    }

    $('body').on('click', modalCloseBtn, () => {
      this.common.sendGoogleEvent(
        EVENT_CATEGORY,
        'Modal Close',
        'Sustainability',
      );
    });

    if ($(READ_MORE_SELECTOR).length) {
      $('body').on('click', READ_MORE_SELECTOR, (e) => {
        const $readMore = $(e.currentTarget);
        const operatorId = $readMore.data('operator-id');

        this.common.sendRequest(
          `/api/operators/${operatorId}/description`,
          {},
          (response) => {
            if (!response.success) {
              console.warn('Error fetching operator description.');
              return;
            }

            $operatorDescription.html(response.full_description);
            $operatorDescription.removeClass('ao-sustainability-operator-description--truncated');
            $readMore.remove();
          },
          { type: 'GET' },
        );
      });
    }
  };

  this.processScroll = () => {
    this.common.byWindowAction(['scroll'], () => {
      if (!this.scrollTimeout) {
        const timeAfterLoad = this.timeAfterLoad();

        this.scrollTimeout = setTimeout(() => {
          this.scrollToElemnt(true, timeAfterLoad, $initiativesBlock, 'Start of Sustainability', 'top');
          this.scrollToElemnt(true, timeAfterLoad, $initiativesBlock, endSustainabilityLabel, 'bottom');
          this.scrollTimeout = null;
        }, 200);
      }
    });
  };

  this.timeAfterLoad = () => Date.now() - timerStart;

  this.scrollToElemnt = (initial, timeAfterLoad, element, blockType, checkType) => {
    const timer = timeAfterLoad || this.timeAfterLoad();

    if (!element.height()) {
      return;
    }

    if (scrollElementList.indexOf(blockType) >= 0) {
      return;
    }

    const elementIsVisible = this.common.func.isElementOnScreen(
      element,
      0,
      checkType,
    );

    if (!elementIsVisible) {
      return;
    }

    scrollElementList.push(blockType);
    this.common.sendGoogleEvent(
      EVENT_CATEGORY,
      SCROLL_ACTION,
      blockType,
      {
        nonInteraction: !!initial,
        eventValue: initial ? 0 : timer,
      },
    );
  };

  this.showPopup = () => {
    $.magnificPopup.open({
      items: {
        src: layout,
      },
      closeOnBgClick: true,
    });
  };
}
